import { UploadStatusEnum } from '../enums/UploadStatusEnum';

/**
 * @group Constants

@summary
<blockquote>Human-readable labels for health record upload statuses.</blockquote>

@example
```typescript
const statusLabel = EHR_UPLOAD_STATUS[upload.uploadStatus];
// "Upload Successful"
```
 * @internal
 */
export const EHR_UPLOAD_STATUS = {
  [UploadStatusEnum.PENDING]: 'Upload Pending',
  [UploadStatusEnum.IN_PROGRESS]: 'Uploading...',
  [UploadStatusEnum.SUCCESS]: 'Upload Successful',
  [UploadStatusEnum.FAILED]: 'Upload Failed',
  [UploadStatusEnum.RETRYING]: 'Retrying Upload',
} as const;
